var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "bus_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#bus_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M8.778 35v-4.778a4.476 4.476 0 0 1-1.583-1.896 6.072 6.072 0 0 1-.528-2.52V9.5c0-2.133 1.065-3.694 3.194-4.683 2.13-.99 5.519-1.484 10.167-1.484 4.667 0 8.05.486 10.152 1.459 2.102.972 3.153 2.541 3.153 4.708v16.305c0 .899-.176 1.739-.528 2.521a4.476 4.476 0 0 1-1.583 1.896V35h-4.055v-3.389H12.833V35H8.778Zm.667-17.528h21.11V11H9.445v6.472Zm4.335 9.417c.656 0 1.213-.23 1.671-.69a2.28 2.28 0 0 0 .688-1.673c0-.656-.23-1.213-.69-1.672a2.28 2.28 0 0 0-1.673-.687c-.656 0-1.213.23-1.672.689a2.281 2.281 0 0 0-.687 1.674c0 .656.23 1.213.689 1.671.46.459 1.017.688 1.674.688Zm12.444 0c.656 0 1.213-.23 1.672-.69a2.28 2.28 0 0 0 .687-1.673c0-.656-.23-1.213-.689-1.672a2.281 2.281 0 0 0-1.674-.687c-.656 0-1.213.23-1.671.689a2.282 2.282 0 0 0-.688 1.674c0 .656.23 1.213.69 1.671a2.28 2.28 0 0 0 1.673.688ZM9.694 8.222h20.667c-.583-.639-1.734-1.15-3.451-1.534-1.718-.385-4.003-.577-6.855-.577-3.175 0-5.576.183-7.2.549-1.626.365-2.679.886-3.16 1.562Zm3.14 20.611h14.333c.953 0 1.756-.358 2.41-1.076.652-.718.978-1.553.978-2.507v-5H9.445v5c0 .954.326 1.79.979 2.507.652.718 1.456 1.076 2.41 1.076Z"
}))));
export default SvgBus;